export const contactsData = {
    email: 'Kareemmagdywilson@gmail.com',
    phone: '+201276537114',
    address: 'Cairo, Egypt',

    sheetAPI: 'https://formspree.io/f/mayknqrv'
}